import { useQueryBuilder } from "../useBuilders";
import { FETCH, LINKEDIN } from "../queryKeys";
import { linkedInApi } from "src/services/integrations/linkedin";

export const useLinkedInPostCountQuery = (assetId: string) => {
  return useQueryBuilder(
    [LINKEDIN, FETCH, assetId],
    () => linkedInApi.fetchPostCount(assetId),
    false,
    0,
    false,
    undefined,
    !!assetId
  );
};
